import usePrivateAxios from '@/common/api/usePrivateAxios'
import { EstablishmentCompanyData } from '@/common/types/establishment/company.type'
import { getRailsUpdate } from '@/common/utils/getRailsUpdate'
import { mapToDeletion } from '@/common/utils/railsHelpers'
import { UpdateGeneralPoliticsValidationSchema } from '@/features/establishments/schemas/politics/updateGeneralPolitics.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateEstablishmentGeneralPoliticsProps {
  establishmentCompany?: EstablishmentCompanyData;
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useUpdateEstablishmentGeneralPolitics = ({ establishmentCompany, onSuccess, onError }: UseUpdateEstablishmentGeneralPoliticsProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEstablishmentGeneralPolitics', establishmentCompany?.id],
    mutationFn: async (form: UpdateGeneralPoliticsValidationSchema) => {
      const payload = {
        company_product_categories_attributes: getRailsUpdate(
          establishmentCompany?.company_product_categories || [],
          form.product_categories || [],
          (x) => x.product_category.id,
          (x) => x.value,
          mapToDeletion,
          (item: { value: string; }) => ({ product_category_id: item.value }),
        ),
        commercial_manager_id: form.commercial_manager?.value,
        time_zone_id: form.time_zone_id?.value,
        allows_refunds_via_pos: form.allows_refunds_via_pos || false
      };

      return privateAxios.put(`/establishment/companies/${establishmentCompany?.id}/update_policies_general_data`, { company: payload });
    },
    onSuccess,
    onError,
  })
}
